import React, { useState, useEffect } from "react";
import { auth, db } from "../firebase"; // تهيئة Firebase
import { getDoc, doc, collection, query, where, getDocs } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import pic from '../assets/download.png';
import logo from '../assets/Rihal_logo-fullcolor-rgb.svg'

const PartnerProfilePage = () => {
  const [user, setUser] = useState(null);
  const [offers, setOffers] = useState([]); // State to store offers
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      // Fetch user data
      const fetchUserData = async () => {
        try {
          const userDoc = await getDoc(doc(db, "users", currentUser.uid));
          if (userDoc.exists()) {
            setUser(userDoc.data()); // Set user data
          } else {
            setError("لم يتم العثور على بيانات المستخدم");
          }
        } catch (err) {
          setError("خطأ في جلب بيانات المستخدم: " + err.message);
        }
      };

      // Fetch user offers
      const fetchOffers = async () => {
        try {
          const offersQuery = query(
            collection(db, "offers"),
            where("userId", "==", currentUser.uid) // Match the userId to the current user's UID
          );
          const querySnapshot = await getDocs(offersQuery);
          const offersList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

          console.log("Fetched offers:", offersList); // Debugging: Log fetched offers

          setOffers(offersList); // Set offers created by the user
        } catch (err) {
          setError("خطأ في جلب العروض: " + err.message);
        }
      };

      // Call both functions
      fetchUserData();
      fetchOffers();

      setLoading(false); // Set loading to false after both tasks are done
    } else {
      // Redirect to login page if user is not authenticated
      navigate("/LoginChoicePage");
    }
  }, [navigate]);

  if (loading) {
    return <div className="text-center text-xl text-gray-600">جاري التحميل...</div>;
  }

  if (error) {
    return <div className="text-center text-xl text-red-500">{error}</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-t from-green-400 via-green-300 to-green-100 flex justify-center items-center py-10">
      <img
              src={logo}
              alt="logo"
              className="bg-transparent blur-sm w-full h-full absolute p-40"
            />
      <div className="bg-white w-full max-w-lg p-8 rounded-xl shadow-xl transform transition-all duration-500 hover:scale-105 hover:shadow-3xl">
        <div className="flex flex-col items-center animate-fade-in">
          <img
            src={user?.photoURL || pic}
            alt="الملف الشخصي"
            className="w-32 h-32 rounded-full object-cover border-4 border-white shadow-lg transform transition-all duration-500 hover:scale-110 hover:shadow-2xl"
          />
          <h1 className="mt-4 text-3xl font-bold text-gray-800">{user?.businessName || "اسم العمل"}</h1>
          <p className="text-lg text-gray-600">{user?.email}</p>
          <p className="text-lg text-gray-600">{user?.phone}</p>
        </div>

        <div className="mt-6">
          <h2 className="text-xl font-semibold text-gray-800">الدور</h2>
          <p className="text-lg text-gray-600">{user?.role}</p>
        </div>
        <div className="mt-8 flex justify-between items-center space-x-4">
          <button
            onClick={() => auth.signOut()}
            className="w-1/2 py-3 bg-red-500 text-white text-lg rounded-lg hover:bg-red-600 transition-colors transform hover:scale-105 duration-300"
          >
            تسجيل الخروج
          </button>
          <Link
            to='/'
            className="w-1/2 py-3 border-2 border-gray-800 text-gray-800 text-lg rounded-lg hover:bg-gray-100 transition-colors transform hover:scale-105 duration-300"
          >
            العودة إلى الصفحة الرئيسية
          </Link>
        </div>

        {/* Displaying offers created by the user */}
        <div className="mt-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">الخدمات/العروض</h2>
          <div className="space-y-4">
            {offers.length > 0 ? (
              offers.map((offer) => (
                <Link to={`/OffersPage/${offer.id}`} key={offer.id}>
                  <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                    <h3 className="text-lg font-semibold text-gray-800">{offer.name || "عرض غير مسمى"}</h3>
                    <p className="text-gray-600 mt-2">{offer.description || "لا يوجد وصف متاح لهذا العرض."}</p>
                    <img src={offer.image || pic} alt={offer.name} className="w-full h-48 object-cover mt-4 rounded-md" />
                    <p className="text-lg text-gray-800 mt-2">{offer.price ? `السعر: ${offer.price} دينار` : "السعر غير متاح"}</p>
                  </div>
                </Link>
              ))
            ) : (
              <p className="text-gray-600">لم تقم بإنشاء أي عروض بعد.</p>
            )}
          </div>
        </div>

      
      </div>
    </div>
  );
};

export default PartnerProfilePage;
